<template>
  <div>
    <div class="info-container">
      <div>
        <SliderComponent />
      </div>
      <div class="info-text">
        <p>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem
          ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur
          sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et
          dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam
          et justo duo dolores et ea
        </p>
      </div>
    </div>
    <div class="info-container">
      <div class="info-text">
        <p>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem
          ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur
          sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et
          dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam
          et justo duo dolores et ea
        </p>
      </div>
      <div>
        <SliderComponent />
      </div>
      ^
    </div>
  </div>
</template>

<script>
import SliderComponent from "@/components/SlideComponent.vue";

export default {
  name: "SliderView",
  data() {
    return {
      position: "p",
    };
  },
  components: {
    SliderComponent,
  },
};
</script>

<style>
.info-container {
  display: flex;
  margin: 25px;
  margin-top: 100px;
}
.info-text {
  display: flex;
}
</style>